import { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import _ from "lodash";

import mystryWord from "assets/images/tw/mystry-word.png";
import yourClue from "assets/images/tw/your-clue.png";
import GuessedWord from "../components/GuessedWord";
import TWWaitingScreen from "../components/TWWaitingScreen";
import {
  fadeInVariants,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";

const TWGuessing = ({ isActivePlayer,
  joke,
  roomId,
  clueSubmitted,
  word,
  screens,
  buzzer_sound,
  default_audio_effect
}) => {
  const instructions = _.get(screens, "waiting_guess.instructions", "WAITING FOR GUESSER..");
  const button_text = _.get(screens, "word_entry_guess.button_text", "YOU'RE UP!");
  const word_entry_guess_placeholder = _.get(screens, "word_entry_guess.hint", "Enter Your Guess Here");

  const [guess, setguess] = useState("");

  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "");
    setguess(inputValue);
  };

  const buttonPressAction = () => {
    if (!_.isEmpty(guess)) {
      const data = {
        action: "submit-guess",
        roomId,
        guess
      };
      Socket.sendMessage(data);
    }
  };
  const handle_submit = useCallback(
    _.debounce(() => buttonPressAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [guess]
  );
  useEffect(() => {
    if (isActivePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect])
  return isActivePlayer ? (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={bounce_right_to_left_variants_without_children}
      className="tw-guessing"
    >
      <div>
        <GuessedWord image={mystryWord} word={"???"} />
        <motion.input
          variants={fadeInVariants}
          type="text"
          name="guess"
          className="input-field"
          placeholder={word_entry_guess_placeholder}
          value={guess}
          onChange={handleChange}
        />
      </div>
      <div
        className="tw-btn-wrapper"
        onClick={() => {
          handle_submit();
        }}
      >
        <div className="tw-btn">{button_text}</div>
      </div>
    </motion.div>
  ) : (
    <TWWaitingScreen
      image={_.isEmpty(clueSubmitted) ? mystryWord : yourClue}
      guessWord={_.isEmpty(clueSubmitted) ? word : clueSubmitted?.word}
      joke={joke}
      description={instructions}
    />
  );
};

export default TWGuessing;
